import * as React from "react";
import "../../Styles/style.css";
import OrdersNavigation from "./inspectionorder-navigation";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { baseUrl } from "../../../api/ipconfig";
import { useEffect, useState } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

const columns = [
  { id: "orderid", label: "Order ID", minWidth: 50 },
  { id: "city", label: "City", minWidth: 70 },
  {
    id: "address",
    label: "Address",
    minWidth: 150,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "inspectionSlot",
    label: "Inspection Slot",
    minWidth: 150,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carDetails",
    label: "Vehicle",
    minWidth: 150,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "fullname",
    label: "Full Name",
    minWidth: 70,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "phone",
    label: "Phone",
    minWidth: 70,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "action",
    label: "Start",
    minWidth: 140,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
];

export default function Inspectionorders() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [inspectionOrders, setInspectionOrders] = useState(null);

  useEffect(() => {
    const fetchInspectionOrders = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `https://onlinepayment.famewheels.com/inspectionrequest`
        );
        setInspectionOrders(response?.data?.initial);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching user posts:", error);
        // setLoading(false);
      }
    };

    fetchInspectionOrders();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handlePendingOrders = () => {
    return inspectionOrders && inspectionOrders.length;
  };

  const history = useHistory();

  const handleButtonClick = async (Id) => {
    history.push(`/inspector-form?inspection=${Id}`);
    try {
      const user = localStorage.getItem("data");
      const userId = JSON.parse(user);

      const formData = new FormData();

      // Append form field values
      formData.append("user_id", userId?.id);
      formData.append("inspection_id", Id);

      const response = await axios.post(
        `https://onlinepayment.famewheels.com/startinspection`,
        formData
      );

    } catch (err) {
      console.error(err.response);
    }
  };

  return (
    <>
      <div className="MyAds_main py-5">
        <div className="container MyAds_body">
          <h3 className="pb-2 fw-700 text-center text-uppercase  fw-title">
            Inspection <span>Orders </span>
          </h3>
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <OrdersNavigation pendingOrders={handlePendingOrders()} />
            </div>
            <div className="col-lg-10">
              <div className="ms-md-3 adsSection">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer
                    className="inspectionOrders"
                    sx={{ minHeight: 440 }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                              className="bgSecondary color-white"
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {inspectionOrders &&
                          inspectionOrders
                            ?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((order, index) => (
                              <TableRow className="bg-light" key={index}>
                                <TableCell>{`#${order.inspection_id}`}</TableCell>
                                <TableCell>{order.city_name}</TableCell>
                                <TableCell>{order.address}</TableCell>
                                <TableCell>{order.inspection_slot}</TableCell>
                                <TableCell>{`${order.make_name} ${order.model_name} ${order.year_name}`}</TableCell>
                                <TableCell>{order.full_name}</TableCell>
                                <TableCell>
                                  <a
                                    href={`tel:${order.phone}`}
                                    className="btn p-0"
                                  >
                                    {order.phone}
                                  </a>
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() =>
                                      handleButtonClick(
                                        `${order?.inspection_id}`
                                      )
                                    }
                                    variant="contained"
                                    className="py-1 px-4 color-white fw-700 bgSecondary  text-capitalize"
                                    key={order.inspection_id}
                                  >
                                    Start
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 100]}
                    component="div"
                    count={inspectionOrders && inspectionOrders.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    className="inspectionOrder_pagi"
                  />
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
